import type { ChartType, RangeKey } from "@chartandgo/shared";

export const RANGE_LABELS: Record<RangeKey, string> = {
  "1D": "1D",
  "5D": "5D",
  "1M": "1M",
  "3M": "3M",
  "6M": "6M",
  YTD: "YTD",
  "1Y": "1Y",
  "5Y": "5Y",
  MAX: "MAX",
};

export const CHART_TYPE_LABELS: Record<ChartType, string> = {
  candlestick: "Candles",
  line: "Line",
  area: "Area",
  bar: "OHLC bars",
};
